import { KAPLAYCtx } from "kaplay";
import { CUBE_SIZE, SHAFT_CENTER_X } from "../../constants";
import { COLORS } from "../../colors";
import { PALETTE } from "../../theme";
import { GameColor } from "../../types";

const COLOR_CHANGE_POP_SCALE = 1.18;

/** The player's cube. Owns only its visuals; position comes from the physics step. */
export function createPlayerCube(k: KAPLAYCtx, centerY: number, color: GameColor) {
    const cube = k.add([
        k.rect(CUBE_SIZE, CUBE_SIZE, { radius: 6 }),
        k.pos(SHAFT_CENTER_X, centerY),
        k.anchor("center"),
        k.color(...COLORS[color].rgb),
        k.outline(3, k.rgb(...PALETTE.white)),
        k.scale(1),
        k.opacity(1),
        k.z(20),
    ]);

    // Glowing core
    cube.add([
        k.rect(CUBE_SIZE * 0.5, CUBE_SIZE * 0.5, { radius: 3 }),
        k.anchor("center"),
        k.color(...PALETTE.white),
        k.opacity(0.8),
        k.z(21),
    ]);

    return {
        moveTo(newCenterY: number) {
            // Reassign pos (not mutate) so KAPLAY picks up the transform change
            cube.pos = k.vec2(SHAFT_CENTER_X, newCenterY);
        },
        showColor(newColor: GameColor) {
            cube.color = k.rgb(...COLORS[newColor].rgb);
            cube.scale = k.vec2(COLOR_CHANGE_POP_SCALE);
        },
        easeBack(dt: number) {
            cube.scale = k.vec2(k.lerp(cube.scale.x, 1, dt * 10));
        },
        hide() {
            cube.hidden = true;
        },
    };
}
